import { render } from "./WaterBillOnlinePay.vue?vue&type=template&id=64a32df2&scoped=true"
import script from "./WaterBillOnlinePay.vue?vue&type=script&lang=js"
export * from "./WaterBillOnlinePay.vue?vue&type=script&lang=js"

import "./WaterBillOnlinePay.vue?vue&type=style&index=0&id=64a32df2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a32df2"]])

export default __exports__